export const isDebugging = () => !!process.env.NEXT_PUBLIC_BICONOMY_SDK_DEBUG || !!process.env.REACT_APP_BICONOMY_SDK_DEBUG || !!process.env.BICONOMY_SDK_DEBUG;
//# sourceMappingURL=Helpers.js.map